import { useEffect, useState } from "react";

export default function SciFiProgressBarnft1({ value = 82 }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgress(value);
    }, 50);

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <div className="w-full">
    

      <div className="relative h-3 overflow-hidden rounded-md border border-orange-400/60 bg-[#0b0b0b]">
        <div
          className="absolute left-0 top-0 h-full overflow-hidden rounded-md shadow-[0_0_18px_rgba(255,145,0,.45)] transition-all duration-1000 ease-out"
          style={{ width: `${progress}%` }}
        >
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(90deg,#ff6a00 0%,#ff9800 45%,#ffc14d 100%)",
            }}
          />

          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
                repeating-linear-gradient(
                  -45deg,
                  rgba(255,255,255,0.18) 0px,
                  rgba(255,255,255,0.18) 8px,
                  rgba(255,170,40,0.08) 8px,
                  rgba(255,170,40,0.08) 16px
                )
              `,
              backgroundSize: "22px 22px",
              animation: "diagonalMove 1s linear infinite",
            }}
          />

          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg,rgba(255,255,255,.22),transparent 45%)",
            }}
          />

          <div className="absolute right-0 top-0 h-full w-5 bg-white/25 blur-sm" />
        </div>
      </div>
    </div>
  );
}